import { render } from "./FleetNoWorkspaces.vue?vue&type=template&id=772d85c5&scoped=true"
import script from "./FleetNoWorkspaces.vue?vue&type=script&lang=js"
export * from "./FleetNoWorkspaces.vue?vue&type=script&lang=js"

import "./FleetNoWorkspaces.vue?vue&type=style&index=0&id=772d85c5&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772d85c5"]])

export default __exports__